import axios from "axios";
import Papa from 'papaparse';
import queryString from 'query-string';

export const actionFlowUrl = 'https://lite.actionflow.net/api/';

const afRequest = async (creds, baseURL, url, params = {}, extraHeaders = {}) => {
    try {
        // first get token
        debugger;
        const postData = queryString.stringify({
            'grant_type': 'client_credentials',
            'client_id': 'fa256b0d-134f-4a95-bba3-d9579e6dddf8',
            'client_secret': 'yWQ8Q~T.ipvzHOYfG6VWRTqULEON_aKFr2ZVaaCF',
        })
        const auth = {
            baseURL: actionFlowUrl,
            method: 'POST',
            url: 'clienttoken',
            headers: {
                username: creds.user,
                password: creds.password,
            },
            data: postData,
            maxRedirects: 20
        };

        const loginRes = await axios(auth);
        debugger;
        const accessToken = loginRes.data.access_token;


        let headers = {}
        if (!Object.keys(extraHeaders).length) {
            headers = {
                'Authorization': `Bearer ${accessToken}`
            }
        } else {
            headers = {
                ...Object.assign({}, extraHeaders),
            }
        }

        const options = {
            baseURL,
            url: url,
            headers,
            ...params
        };
        console.log({options})

        const response = await axios(options);
        return response.data;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            if (error.response.data.details) {
                console.log(error.response.data.details);
            }
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
        }
        throw error;
    }
}

const makeSendCSV = async (creds, res) => {
    const client = res.details.client
    const accepted = res.details.cart.accepted
    debugger;

    const data = accepted.map(x => ({
        'offeringName': x.sales_option,
        'offeringQuantity': res.details.cart.quantity[x.id],
        'offeringPrice': `$${(x.price / 100).toFixed(2)}`,
        'offeringUnit': x.unit_type,
        'clientName': client.name,
        'cartSeller': res.seller,
        'cartCheckoutFinalized': res.created,
    }))

    const csvData = Papa.unparse(data);
    const blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
    const formData = new FormData();
    const today = new Date();
    const fileName = `${client.job}_${client.location}_${today.toISOString().split('T')[0]}`;
    formData.append('file', blob, fileName);

    try {
        let responseLocation = await afRequest(creds, actionFlowUrl, `Jobs/newfile/?jobNumForSAS=${parseInt(res.details.client.job)}&fileName=${fileName}.csv&folderstring=hotsauce`, {
            method: 'GET',
        },);
    } catch (e) {
        window.alert("Please check your Action Flow credentials...")
    }

    try {
        debugger;
        let fileUpload = await afRequest(creds, responseLocation, '', {
                method: 'PUT',
                data: formData,
            },
            {
                'Content-Type': 'multipart/form-data',
                'x-ms-blob-type': 'BlockBlob',
                'x-ms-meta-DateUploaded': new Date().toUTCString(),
                'x-ms-meta-HasSignature': '',
            }
        );
        debugger;
        console.log('Response:', fileUpload.data);

        return await afRequest(creds, actionFlowUrl, `/Actions/createHSAlert?jobNum=${res.details.client.job}`, {
            method: 'POST',
        });
    } catch (e) {
        console.log({e})
    }
}

const getJob = async (creds, jobId) => {
    try {
        let response = await afRequest(creds, actionFlowUrl, `/Jobs/hotSauce?jobNum=${jobId}`, {
            method: 'GET',
        });
        return response;
    } catch (error) {
        throw error;
    }
};

export default {
    getJob,
    makeSendCSV,
};